import React from "react";

const normalizeItem = (item) => {
  if (typeof item === "string") {
    const text = item.trim();
    return text ? { type: "text", text } : null;
  }
  if (!item || typeof item !== "object") return null;
  if (item.type === "image" && item.src) {
    return {
      type: "image",
      src: item.src,
      alt: item.alt || item.title || "",
      title: item.title || item.alt || "",
    };
  }
  const text = String(item.label || item.text || "").trim();
  return text ? { type: "text", text } : null;
};

const Breadcrumb = ({ items = [], className = "", style = {} }) => {
  const visibleItems = items.map(normalizeItem).filter(Boolean);

  if (visibleItems.length === 0) return null;

  return (
    <nav
      className={className}
      aria-label="当前位置"
      style={{
        display: "inline-flex",
        alignItems: "center",
        minWidth: 0,
        maxWidth: "100%",
        color: "rgba(203, 213, 225, 0.72)",
        fontSize: "11px",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {visibleItems.map((item, index) => {
        const isLast = index === visibleItems.length - 1;
        const key =
          item.type === "image"
            ? `img-${item.src}-${index}`
            : `${item.text}-${index}`;

        return (
          <React.Fragment key={key}>
            {index > 0 && (
              <span
                aria-hidden="true"
                style={{
                  margin: "0 6px",
                  color: "rgba(148, 163, 184, 0.46)",
                }}
              >
                /
              </span>
            )}
            {item.type === "image" ? (
              <span
                className="breadcrumb-platform-mark"
                title={item.title || item.alt}
                aria-label={item.alt || item.title || "邮百工"}
              >
                <img src={item.src} alt={item.alt || "邮百工"} draggable={false} />
              </span>
            ) : (
              <span
                title={item.text}
                style={{
                  minWidth: 0,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  color: isLast
                    ? "rgba(226, 232, 240, 0.92)"
                    : "rgba(148, 163, 184, 0.76)",
                  fontWeight: isLast ? 600 : 500,
                }}
              >
                {item.text}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumb;
